import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { Interactable } from 'LocalGluons';
import FaIcon from 'react-native-vector-icons/FontAwesome';
import Theme from 'Theme';
import type { LanguageButtonProps } from '../LanguageButton/LanguageButton';
import styles from './styles';

interface SelectButtonProps {
    label: LanguageButtonProps['label'];
    onPress: () => void;
}

const SelectButton = ({ label, onPress }: SelectButtonProps): JSX.Element => (
    <Interactable style={styles.selectButton} onPress={onPress}>
        <Text style={styles.selectButtonLabel}>{label}</Text>
        <FaIcon
            style={StyleSheet.flatten(styles.selectButtonIcon)}
            size={8}
            name="chevron-down"
            color={Theme.secondaryButtonBorderColor}
        />
    </Interactable>
);

export default SelectButton;
